"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BankSyncSearch;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ToolsDate_1 = __importDefault(require("../../React/Tools/ToolsDate"));
const Tools_1 = __importDefault(require("../../React/Tools/Tools"));
const BankSyncController_1 = require("./BankSyncController");
const AllocationModal_1 = __importDefault(require("./AllocationModal"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const BankTransferFilterBody_1 = require("./BankTransferFilterBody");
require("./BankSyncSearch.css");
/* ------------------------------------------------------------------ */
/* Shared helpers                                                       */
/* ------------------------------------------------------------------ */
function DirectionBadge({ direction }) {
    return direction === 'IN'
        ? react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success" }, "\u2193 IN")
        : react_1.default.createElement(react_bootstrap_1.Badge, { bg: "danger" }, "\u2191 OUT");
}
function StatusBadge({ status }) {
    const map = {
        UNMATCHED: ['secondary', 'Nierozliczone'],
        PROPOSED: ['warning', 'Proponowane'],
        CONFIRMED: ['success', 'Potwierdzone'],
        MANUAL: ['info', 'Ręczne'],
    };
    const [bg, label] = map[status] ?? ['light', status];
    return react_1.default.createElement(react_bootstrap_1.Badge, { bg: bg }, label);
}
function fmt(n, currency = 'PLN') {
    return `${Tools_1.default.formatNumber(n)} ${currency}`;
}
function fmtDate(d) {
    return d ? ToolsDate_1.default.dateYMDtoDMY(d) : '-';
}
function TransferRow({ transfer, onManage, showActions = false }) {
    return (react_1.default.createElement("tr", null,
        react_1.default.createElement("td", { className: "text-nowrap" }, fmtDate(transfer.execDate)),
        react_1.default.createElement("td", null,
            react_1.default.createElement(DirectionBadge, { direction: transfer.direction })),
        react_1.default.createElement("td", { className: "text-end text-nowrap fw-semibold" }, fmt(transfer.amount, transfer.currency)),
        react_1.default.createElement("td", { style: { minWidth: 120, maxWidth: 200 } }, transfer.counterpartyName ?? '-'),
        react_1.default.createElement("td", { style: { minWidth: 160 } },
            react_1.default.createElement("small", null, transfer.description ?? '-')),
        react_1.default.createElement("td", null,
            react_1.default.createElement(StatusBadge, { status: transfer.matchingStatus })),
        showActions && (react_1.default.createElement("td", null,
            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", onClick: () => onManage?.(transfer) }, "Alokacje")))));
}
function transferTableHeader(showActions) {
    return (react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("th", null, "Data"),
            react_1.default.createElement("th", null, "Kier."),
            react_1.default.createElement("th", { className: "text-end" }, "Kwota"),
            react_1.default.createElement("th", null, "Kontrahent"),
            react_1.default.createElement("th", null, "Opis"),
            react_1.default.createElement("th", null, "Status"),
            showActions && react_1.default.createElement("th", null))));
}
/* ------------------------------------------------------------------ */
/* Transfers tab — standard FilterableTable pattern                    */
/* ------------------------------------------------------------------ */
function TransfersTab({ onRefresh }) {
    const [managed, setManaged] = (0, react_1.useState)(null);
    const [externalUpdate, setExternalUpdate] = (0, react_1.useState)(0);
    function handleAllocChanged() {
        setManaged(null);
        setExternalUpdate(k => k + 1);
        onRefresh?.();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterableTable_1.default, { id: "bankTransfers", title: "", repository: BankSyncController_1.bankTransfersRepository, FilterBodyComponent: BankTransferFilterBody_1.BankTransferFilterBody, isDeletable: false, isCopyable: false, externalUpdate: externalUpdate, tableStructure: [
                { header: 'Data', renderTdBody: (t) => react_1.default.createElement(react_1.default.Fragment, null, fmtDate(t.execDate)), colMd: 1 },
                { header: 'Kier.', renderTdBody: (t) => react_1.default.createElement(DirectionBadge, { direction: t.direction }), colMd: 1 },
                { header: 'Kwota', renderTdBody: (t) => react_1.default.createElement("span", { className: "fw-semibold text-nowrap" }, fmt(t.amount, t.currency)), colMd: 2 },
                { header: 'Kontrahent', renderTdBody: (t) => react_1.default.createElement(react_1.default.Fragment, null, t.counterpartyName ?? '-'), colMd: 2 },
                { header: 'Opis', renderTdBody: (t) => react_1.default.createElement("small", { className: "text-muted" }, t.description ?? '-'), colMd: 4 },
                { header: 'Status', renderTdBody: (t) => react_1.default.createElement(StatusBadge, { status: t.matchingStatus }), colMd: 1 },
                {
                    header: '',
                    renderTdBody: (t) => (react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", onClick: () => setManaged(t) }, "Alokacje")),
                    colMd: 1,
                },
            ] }),
        managed && (react_1.default.createElement(AllocationModal_1.default, { transfer: managed, onHide: () => setManaged(null), onChanged: handleAllocChanged }))));
}
/* ------------------------------------------------------------------ */
/* Pending tab — UNMATCHED + PROPOSED transfers needing attention      */
/* ------------------------------------------------------------------ */
function PendingTab({ onRefresh }) {
    const [transfers, setTransfers] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [managed, setManaged] = (0, react_1.useState)(null);
    const load = (0, react_1.useCallback)(async () => {
        setLoading(true);
        setError(null);
        try {
            setTransfers(await (0, BankSyncController_1.fetchPendingTransfers)());
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Błąd ładowania');
        }
        finally {
            setLoading(false);
        }
    }, []);
    (0, react_1.useEffect)(() => { load(); }, [load]);
    function handleAllocChanged() {
        load();
        onRefresh?.();
    }
    const unmatched = transfers.filter(t => t.matchingStatus === 'UNMATCHED');
    const proposed = transfers.filter(t => t.matchingStatus === 'PROPOSED');
    if (loading)
        return react_1.default.createElement("div", { className: "text-center py-4" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border" }));
    if (error)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error);
    if (transfers.length === 0) {
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" }, "Brak przelew\u00F3w oczekuj\u0105cych na obs\u0142ug\u0119.");
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mb-3 d-flex gap-3" },
            react_1.default.createElement("span", null,
                "Oczekuje na obs\u0142ug\u0119: ",
                react_1.default.createElement("strong", null, transfers.length)),
            react_1.default.createElement("span", null,
                "Nierozliczone: ",
                react_1.default.createElement("strong", null, unmatched.length)),
            react_1.default.createElement("span", null,
                "Proponowane: ",
                react_1.default.createElement("strong", null, proposed.length))),
        proposed.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h6", null, "Proponowane dopasowania \u2014 wymagaj\u0105 zatwierdzenia"),
            react_1.default.createElement("div", { className: "table-responsive mb-4" },
                react_1.default.createElement(react_bootstrap_1.Table, { striped: true, hover: true, size: "sm", className: "bank-sync-table" },
                    transferTableHeader(true),
                    react_1.default.createElement("tbody", null, proposed.map(t => (react_1.default.createElement(TransferRow, { key: t.id, transfer: t, showActions: true, onManage: setManaged })))))))),
        unmatched.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h6", null, "Nierozliczone \u2014 wymagaj\u0105 r\u0119cznej alokacji"),
            react_1.default.createElement("div", { className: "table-responsive" },
                react_1.default.createElement(react_bootstrap_1.Table, { striped: true, hover: true, size: "sm", className: "bank-sync-table" },
                    transferTableHeader(true),
                    react_1.default.createElement("tbody", null, unmatched.map(t => (react_1.default.createElement(TransferRow, { key: t.id, transfer: t, showActions: true, onManage: setManaged })))))))),
        managed && (react_1.default.createElement(AllocationModal_1.default, { transfer: managed, onHide: () => setManaged(null), onChanged: handleAllocChanged }))));
}
/* ------------------------------------------------------------------ */
/* Duplicates tab                                                       */
/* ------------------------------------------------------------------ */
function DuplicatesTab() {
    const [groups, setGroups] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const loaded = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (loaded.current)
            return;
        loaded.current = true;
        setLoading(true);
        (0, BankSyncController_1.fetchDuplicates)()
            .then(setGroups)
            .catch(e => setError(e instanceof Error ? e.message : 'Błąd'))
            .finally(() => setLoading(false));
    }, []);
    if (loading)
        return react_1.default.createElement("div", { className: "text-center py-4" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border" }));
    if (error)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error);
    if (groups.length === 0)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" }, "Brak duplikat\u00F3w przelew\u00F3w.");
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mb-3" },
            "Znaleziono ",
            react_1.default.createElement("strong", null, groups.length),
            " grup potencjalnych duplikat\u00F3w."),
        groups.map(group => (react_1.default.createElement("div", { key: `${group.type}-${group.signal}`, className: "mb-4 border rounded p-3" },
            react_1.default.createElement("div", { className: "mb-2" },
                react_1.default.createElement(react_bootstrap_1.Badge, { bg: group.type === 'COUNTERPARTY' ? 'primary' : 'warning', className: "me-2" }, group.type === 'COUNTERPARTY' ? 'Kontrahent + kwota' : 'Nr faktury'),
                react_1.default.createElement("strong", null, group.signal),
                react_1.default.createElement("span", { className: "text-muted ms-2" },
                    "(",
                    group.transfers.length,
                    " przelewy)")),
            react_1.default.createElement(react_bootstrap_1.Table, { size: "sm", className: "mb-0" },
                transferTableHeader(false),
                react_1.default.createElement("tbody", null, group.transfers.map(t => react_1.default.createElement(TransferRow, { key: t.id, transfer: t })))))))));
}
/* ------------------------------------------------------------------ */
/* Wadium tab                                                           */
/* ------------------------------------------------------------------ */
function WadiumTab() {
    const [matches, setMatches] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const loaded = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (loaded.current)
            return;
        loaded.current = true;
        setLoading(true);
        (0, BankSyncController_1.fetchWadiumMatches)()
            .then(setMatches)
            .catch(e => setError(e instanceof Error ? e.message : 'Błąd'))
            .finally(() => setLoading(false));
    }, []);
    if (loading)
        return react_1.default.createElement("div", { className: "text-center py-4" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border" }));
    if (error)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error);
    if (matches.length === 0)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Brak wadi\u00F3w got\u00F3wkowych do weryfikacji.");
    const returned = matches.filter(m => m.isReturned);
    const pending = matches.filter(m => !m.isReturned);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("p", { className: "text-muted mb-3" },
            "Wadium got\u00F3wkowe: ",
            react_1.default.createElement("strong", null, matches.length),
            "\u00A0|\u00A0 Zwr\u00F3cone: ",
            react_1.default.createElement("strong", null, returned.length),
            "\u00A0|\u00A0 Oczekuj\u0105 zwrotu: ",
            react_1.default.createElement("strong", null, pending.length)),
        matches.map(m => {
            const bond = m.bond;
            return (react_1.default.createElement("div", { key: bond.id, className: `mb-4 border rounded p-3 ${m.isReturned ? 'border-success' : 'border-warning'}` },
                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-start mb-2" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, bond.offerAlias ?? `Oferta #${bond.offerId}`),
                        react_1.default.createElement("span", { className: "ms-2 text-muted" },
                            "Wadium #",
                            bond.id)),
                    react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center" },
                        react_1.default.createElement("span", { className: "fw-semibold" }, fmt(bond.value)),
                        m.isReturned
                            ? react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success" }, "Zwr\u00F3cone")
                            : react_1.default.createElement(react_bootstrap_1.Badge, { bg: "warning", text: "dark" }, "Do zwrotu"),
                        react_1.default.createElement(react_bootstrap_1.Badge, { bg: "secondary" }, bond.status))),
                bond.expiryDate && (react_1.default.createElement("small", { className: "text-muted d-block mb-2" },
                    "Wa\u017Cne do: ",
                    fmtDate(bond.expiryDate))),
                m.matchingTransfers.length === 0
                    ? react_1.default.createElement(react_bootstrap_1.Alert, { variant: "secondary", className: "py-1 mb-0 small" }, "Brak pasuj\u0105cych przelew\u00F3w przychodz\u0105cych z \"wadium\" w opisie.")
                    : react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("small", { className: "text-muted fw-semibold d-block mb-1" },
                            "Pasuj\u0105ce przelewy (",
                            m.matchingTransfers.length,
                            "):"),
                        react_1.default.createElement(react_bootstrap_1.Table, { size: "sm", className: "mb-0" },
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", null, "Data"),
                                    react_1.default.createElement("th", { className: "text-end" }, "Kwota"),
                                    react_1.default.createElement("th", null, "Kontrahent"),
                                    react_1.default.createElement("th", null, "Opis"),
                                    react_1.default.createElement("th", null, "Status"))),
                            react_1.default.createElement("tbody", null, m.matchingTransfers.map(t => (react_1.default.createElement("tr", { key: t.id },
                                react_1.default.createElement("td", { className: "text-nowrap" }, fmtDate(t.execDate)),
                                react_1.default.createElement("td", { className: "text-end text-nowrap" }, fmt(t.amount, t.currency)),
                                react_1.default.createElement("td", { className: "text-truncate", style: { maxWidth: 160 } }, t.counterpartyName ?? '-'),
                                react_1.default.createElement("td", { className: "text-truncate", style: { maxWidth: 280 } },
                                    react_1.default.createElement("small", null, t.description ?? '-')),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(StatusBadge, { status: t.matchingStatus }))))))))));
        })));
}
/* ------------------------------------------------------------------ */
/* Upload modal                                                         */
/* ------------------------------------------------------------------ */
function UploadModal({ show, onHide, onCommitted }) {
    const [file, setFile] = (0, react_1.useState)(null);
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const [committing, setCommitting] = (0, react_1.useState)(false);
    const [preview, setPreview] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const [success, setSuccess] = (0, react_1.useState)(null);
    function reset() { setFile(null); setPreview(null); setError(null); setSuccess(null); }
    function handleClose() { reset(); onHide(); }
    async function handleUpload() {
        if (!file)
            return;
        setUploading(true);
        setError(null);
        try {
            setPreview(await (0, BankSyncController_1.uploadBankStatement)(file));
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Błąd importu');
        }
        finally {
            setUploading(false);
        }
    }
    async function handleCommit() {
        if (!preview)
            return;
        setCommitting(true);
        setError(null);
        try {
            const r = await (0, BankSyncController_1.commitStatement)(preview.statementId);
            setSuccess(`Zatwierdzono ${r.committed} alokacji.`);
            onCommitted();
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Błąd zatwierdzania');
        }
        finally {
            setCommitting(false);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: handleClose },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Import wyci\u0105gu bankowego (XML PKO BP)")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
            success && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" }, success),
            !preview && !success && (react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Plik XML z PKO BP"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", accept: ".xml", onChange: e => setFile(e.target.files?.[0] ?? null) }))),
            preview && !success && (react_1.default.createElement("div", { className: "bank-sync-preview" },
                react_1.default.createElement("p", { className: "mb-1" },
                    react_1.default.createElement("strong", null, "Podgl\u0105d importu:")),
                react_1.default.createElement("ul", { className: "mb-0" },
                    react_1.default.createElement("li", null,
                        "\u0141\u0105cznie operacji: ",
                        react_1.default.createElement("strong", null, preview.total)),
                    react_1.default.createElement("li", null,
                        "Automatycznie dopasowanych: ",
                        react_1.default.createElement("strong", null, preview.autoMatched)),
                    react_1.default.createElement("li", null,
                        "Proponowanych dopasowa\u0144: ",
                        react_1.default.createElement("strong", null, preview.proposed)),
                    react_1.default.createElement("li", null,
                        "Bez dopasowania: ",
                        react_1.default.createElement("strong", null, preview.unmatched)),
                    react_1.default.createElement("li", null,
                        "Op\u0142aty bankowe (pomini\u0119te): ",
                        react_1.default.createElement("strong", null, preview.fees)),
                    preview.foreignCurrency > 0 && (react_1.default.createElement("li", null,
                        "Waluty obce (pomini\u0119te): ",
                        react_1.default.createElement("strong", null, preview.foreignCurrency)))),
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "mt-3 mb-0" }, "Kliknij \"Zatwierd\u017A\" aby potwierdzi\u0107 proponowane dopasowania i zaktualizowa\u0107 statusy faktur.")))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: handleClose }, success ? 'Zamknij' : 'Anuluj'),
            !preview && !success && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleUpload, disabled: !file || uploading }, uploading ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border", className: "me-1" }),
                "Importuj\u0119\u2026") : 'Importuj')),
            preview && !success && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: handleCommit, disabled: committing }, committing ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border", className: "me-1" }),
                "Zatwierdzam\u2026") : 'Zatwierdź')))));
}
/* ------------------------------------------------------------------ */
/* Main component                                                       */
/* ------------------------------------------------------------------ */
function BankSyncSearch({ title }) {
    const [showUpload, setShowUpload] = (0, react_1.useState)(false);
    const [refreshKey, setRefreshKey] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => { document.title = title; }, [title]);
    function handleCommitted() { setRefreshKey(k => k + 1); }
    function handleAllocChanged() { setRefreshKey(k => k + 1); }
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "mt-3" },
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3" },
            react_1.default.createElement("h4", { className: "mb-0" }, title),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", onClick: () => setShowUpload(true) }, "Importuj wyci\u0105g XML")),
        react_1.default.createElement(UploadModal, { show: showUpload, onHide: () => setShowUpload(false), onCommitted: handleCommitted }),
        react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "pending", className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "pending", title: "Oczekuj\u0105ce" },
                react_1.default.createElement(PendingTab, { key: refreshKey, onRefresh: handleAllocChanged })),
            react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "transfers", title: "Wszystkie przelewy" },
                react_1.default.createElement(TransfersTab, { key: refreshKey, onRefresh: handleAllocChanged })),
            react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "duplicates", title: "Duplikaty" },
                react_1.default.createElement(DuplicatesTab, { key: refreshKey })),
            react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "wadium", title: "Wadium" },
                react_1.default.createElement(WadiumTab, { key: refreshKey })))));
}
